import React, { useState } from "react";
import "../../styles/ChecklistCard.css";
import ChecklistCard from "../../components/ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import importantNotes from "../../data/BritishColumbia/importantNotes.js";
import ImportantNotes from "../../components/ImportantNotes.js";

export default function Referral() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const PreConReferralData = [
    "Builder Referral Agreement",
    "Disclosure of Referral Payment To Be Received",
  ];

  const [ReferralData, setReferralData] = useState([
    "Referral Agreement",
    "Disclosure of Referral Payment To Be Received",
  ]);

  const handleReferralType = (e) => {
    setReferralType(e.target.value);
    if (e.target.value === "Referring Client Out") {
      setReferralData([
        "Referral Agreement",
        "Disclosure of Referral Payment To Be Received",
      ]);
    } else {
      setReferralData([
        "Referral Agreement",
        "Disclosure of Referral Payment (in WEBForms)",
      ]);
    }
  };

  const [ReferralType, setReferralType] = useState("Referring Client Out");

  const handleThirdParty = (e) => {
    setReferralType(e.target.value);
    setReferralData(["Disclosure of Referral Payment To Be Received"]);
  };
  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <div className="pr-5 ">Referral Type?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="Referring Client Out"
              >
                <FormControlLabel
                  value="Referring Client Out"
                  control={<Radio size="small" onClick={handleReferralType} />}
                  label="Receiving Referral Payment (Referring Client Out)"
                />

                <FormControlLabel
                  value="Receiving Client"
                  control={<Radio size="small" onClick={handleReferralType} />}
                  label="Referral Payment to another Agent (Receiving Client)"
                />
                <FormControlLabel
                  value="Referral to Builder"
                  control={<Radio size="small" onClick={handleReferralType} />}
                  label="Referral to Builder"
                />
                <FormControlLabel
                  value="Referral to Third Party"
                  control={<Radio size="small" onClick={handleThirdParty} />}
                  label="Referral to 3rd Party (Mortgage Broker, etc.)"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          <div>
            <br />
            <a
              href="https://drive.google.com/drive/folders/1NlFHAJ8wdgCPshm-CPKijPmxtAjkfJmU"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click Here{" "}
            </a>{" "}
            for Referral Documents that are not found in WEBForms
          </div>
        </div>
      </div>

      {ReferralType === "Referring Client Out" ||
      ReferralType === "Receiving Client" ||
      ReferralType === "Referral to Third Party" ? (
        <ChecklistCard
          province={"BC"}
          Title1={""}
          CheckListData={ReferralData}
          Header={ReferralType}
          Header2={""}
        />
      ) : (
        <ChecklistCard
          province={"BC"}
          Title1={""}
          CheckListData={PreConReferralData}
          Header={"Referral of Client to Builder"}
          Header2={""}
        />
      )}
      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>

        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("referral") === true
          )}
        />
      </div>
    </div>
  );
}
